import { useField } from 'formik'
import { Stack } from '@mui/material'

import { PasswordInput, PasswordInputProps } from '../Password'

import { PasswordRequirementsList } from './parts/RequirementsList'

type NewPasswordInputProps = PasswordInputProps

export function NewPasswordInput({ name, ...props }: NewPasswordInputProps) {
  const [field] = useField<string>(name)
  const password = field.value

  return (
    <Stack spacing={1} flex={1}>
      <PasswordInput name={name} {...props} />
      {password && <PasswordRequirementsList password={password} />}
    </Stack>
  )
}
